exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#investmentsRegister .v--modal-box.v--modal{min-height:350px!important;min-width:685px!important}#investmentsRegister .modal__footer{display:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41411906","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/management/modals/InvestmentsRegister.vue
// module id = 2227
// module chunks = 0